import React, {Fragment} from 'react';
import { connect } from 'react-redux';
import { change, Field } from "redux-form";

import ExpandSection from "../../Generic/expandSection";
import { setActiveWebHookDataType, toggleSectionOpened } from "../AccountActions";
import { ACCOUNT_SECTIONS } from "./sectionNames";
import { FormField, FormCheckBoxField, FormTextAreaField } from "../FormField";
import SimpleDropDown from "../../PageLayout/DropDowns/SimpleDropDown/SimpleDropDown";
import { store } from "../../../main";
import BlueDropDown from '../../PageLayout/DropDowns/BlueDropDown'
import { formCheckBoxField } from '../../AddNewEntity/formField';

class GeneralSettings extends React.Component {

  updateWebHookDataType = activeWebHookDataType => {
    this.props.setActiveWebHookDataType(activeWebHookDataType);
    store.dispatch(change('newEntity', 'webHookProperties.dataType', activeWebHookDataType));
  }

  updateWebHookCheckBox = chkBox => {
    chkBox.value = !!chkBox.value;
    store.dispatch(change('newEntity', chkBox.name, !chkBox.value));
  }

  render() {

    const { isSiteAdmin, canEditFields } = this.props.accountPageInfo;
    const {formValues, AR} = this.props;
    const activeWebHookDataType = formValues.webHookProperties && formValues.webHookProperties.dataType
      ? formValues.webHookProperties.dataType
      : this.props.activeWebHookDataType;

    const IMEItems = [
      {key: 33, value: "Lixil US"},
      {key: 38, value: "Lowe's Canada"},
      {key: 39, value: "Reno Depot"},
      {key: 40, value: "Rona"}
    ];

    const getIMEItem = (key) => {
      for(const indx in IMEItems) {
        const item = IMEItems[indx];
        if(item.key == key) {
          return item;
        }
      }
      return IMEItems[0];
    };

    const hasSeveralSubscriptions = ["kitchen", "bathroom", "fireplace", "laundryroom"].filter((tool) => {
      return this.props.subscriptionsInfo[`${tool}ProgramType`] && (this.props.subscriptionsInfo[`${tool}ProgramType`] !== "Select")
    }).length > 1;

    return (
      <ExpandSection opened={this.props.sectionsOpened.includes(ACCOUNT_SECTIONS.general_settings)}
        onClick={() => this.props.toggleSectionOpened(ACCOUNT_SECTIONS.general_settings)}
        title="General Settings">
        <div className="acc-container">
          <ul className="acc-list">
            <li className="acc-container__row">
              <div className="acc-block">
                <div className="acc-checkbox">
                  <SimpleDropDown id="webHookDataTypeDropdown" values={["Json", "FormData", "KeyValuePairJson"]}
                    activeValue={activeWebHookDataType} label="Select DataType"
                    disabled={!canEditFields}
                    onChange={(value) => this.updateWebHookDataType(value)} />
                </div>
                <div className="acc-checkbox">
                  <SimpleDropDown id="Language" values={["en-US", "en-AU", "fr-FR", "pl-PL", "es-ES"]}
                    activeValue={formValues.language || "en-US"} label="Language"
                    disabled={!canEditFields}
                    onChange={(value) => store.dispatch(change('newEntity', 'language', value))} />
                </div>
                <div className="acc-checkbox">
                  <SimpleDropDown id="Measurement" values={["imperial", "metric"]}
                    activeValue={formValues.measurement || "Imperial"} label="Measurement"
                    disabled={!canEditFields}
                    onChange={(value) => store.dispatch(change('newEntity', 'measurement', value))} />
                </div>
                {/*<div className="acc-three">*/}
                {/*  <div className="acc-three__item">*/}
                {/*    <Field name="markUpPercentage" component={FormField} label="Mark-up Percentage"*/}
                {/*           disabled={!canEditFields}*/}
                {/*           onChange={(value) => store.dispatch(change('newEntity', 'markUpPercentage', value))} percent={true} />*/}
                {/*  </div>*/}
                {/*</div>*/}
              </div>
              <div className="acc-block">
                <Field name="webHookProperties.url" component={FormField} label="WebHook Url"
                  disabled={!canEditFields} />
                <Field name="webHookProperties.headers" component={FormTextAreaField} label="Headers"
                  disabled={!canEditFields} />
                <span>Enter each header on a new line in "header: value" format, for example: "Token: name@domain.com"</span>
                <Field name="webHookProperties.onNewJob" component={FormCheckBoxField} onChecked={this.updateWebHookCheckBox}
                  labelEnabled="Enable Webhook On New Job Creation"
                  labelDisabled="Enable Webhook On New Job Creation"
                  disabled={!canEditFields} />
                <Field name="webHookProperties.onUpdateJob" component={FormCheckBoxField} onChecked={this.updateWebHookCheckBox}
                  labelEnabled="Enable Webhook On Job Update"
                  labelDisabled="Enable Webhook On Job Update"
                  disabled={!canEditFields} />
                <Field name="webHookProperties.disableFromDashboard" component={FormCheckBoxField} onChecked={this.updateWebHookCheckBox}
                  labelEnabled="Disable Webhook From Dashboard"
                  labelDisabled="Disable Webhook From Dashboard"
                  disabled={!canEditFields} />
                <Field name="webHookProperties.useLeadConduit" component={FormCheckBoxField} onChecked={this.updateWebHookCheckBox}
                  labelEnabled="Use LeadConduit"
                  labelDisabled="Use LeadConduit"
                  disabled={!canEditFields} />
                <Field name="webHookProperties.useSalesForce" component={FormCheckBoxField} onChecked={this.updateWebHookCheckBox}
                  labelEnabled="Use SalesForce (Place domain only in URL field)"
                  labelDisabled="Use SalesForce (Place domain only in URL field)"
                  disabled={!canEditFields} />
                <Field name="joinIMEModerno" component={FormCheckBoxField} onChecked={this.updateWebHookCheckBox}
                  labelEnabled="Send Reduced API Response"
                  labelDisabled="Send Reduced API Response"
                  disabled={!isSiteAdmin} value={formValues.joinIMEModerno} />
                <Field name="useTrumbleApi" component={FormCheckBoxField} onChecked={this.updateWebHookCheckBox}
                  labelEnabled="Enable Trumbull API"
                  labelDisabled="Enable Trumbull API"
                  disabled={!isSiteAdmin} value={formValues.useTrumbleApi} />
                <Field name="useShipperHQ" component={FormCheckBoxField} onChecked={this.updateWebHookCheckBox}
                  labelEnabled="Use Shipper HQ"
                  labelDisabled="Use Shipper HQ"
                  disabled={!isSiteAdmin} value={formValues.useTrumbleApi} />
                <Field name="useOnTrack" component={FormCheckBoxField} onChecked={this.updateWebHookCheckBox}
                  labelEnabled="Use Service Monster Leads"
                  labelDisabled="Use Service Monster Leads"
                  disabled={!isSiteAdmin} value={formValues.useOnTrack} />

                { AR.isSiteAdmin() ?
                  <Fragment>
                    <Field name="webHookProperties.useIMEAPI" component={FormCheckBoxField} onChecked = {this.updateWebHookCheckBox}
                          labelEnabled = "Use IME API Instead of Webhook"
                          labelDisabled = "Use IME API Instead of Webhook" />
                      { formValues.webHookProperties && formValues.webHookProperties.useIMEAPI ?
                        <div style={{paddingLeft: '35px'}}>
                          <BlueDropDown items={IMEItems} rt-if="AR.isSiteAdmin()"
                            onItemClick={(item) => store.dispatch(change('newEntity', 'webHookProperties.useIMEAPI_partnerId', item.key))}
                            selectedItem={getIMEItem(formValues.webHookProperties.useIMEAPI_partnerId)}
                            itemKey={(item) => item.key}
                            itemValue={(item) => item.key + " : " + item.value}
                            title="IME ParentId Value"
                          ></BlueDropDown>
                        </div>
                      : null }
                    {hasSeveralSubscriptions ? (
                      <Field name="useVisualizerSwitching" component={FormCheckBoxField} onChecked={this.updateWebHookCheckBox}
                             labelEnabled="Use Visualizer Switching"
                             labelDisabled="Use Visualizer Switching"
                             disabled={!isSiteAdmin} value={formValues.useVisualizerSwitching} />
                    ) : null}
                    <Field name="useDifferentCurrencies" component={FormCheckBoxField} onChecked={this.updateWebHookCheckBox}
                           labelEnabled="Use Different Currencies"
                           labelDisabled="Use Different Currencies"
                           disabled={!isSiteAdmin} value={formValues.useDifferentCurrencies} />
                  </Fragment>
                : null }
                <Field name="useMarkUpFeaturesRequests"
                       component={FormCheckBoxField}
                       onChecked={this.updateWebHookCheckBox}
                       labelEnabled="Use Mark Up Features Requests"
                       labelDisabled="Use Mark Up Features Requests"
                       disabled={!canEditFields} />
              </div>
            </li>
          </ul>
        </div>
      </ExpandSection>
    )
  }

}

const mapStateToProps = (store) => {
  const { sectionsOpened, accountPageInfo, activeWebHookDataType, subscriptionsInfo } = store.accountState;
  return {
    subscriptionsInfo,
    sectionsOpened,
    accountPageInfo,
    activeWebHookDataType,
    formValues: (store.form && store.form.newEntity && store.form.newEntity.values) || {}
  };
};

const mapDispatchToProps = {
  toggleSectionOpened,
  setActiveWebHookDataType
};

export default connect(mapStateToProps, mapDispatchToProps)(GeneralSettings);

